import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AppBar, Toolbar, Typography, IconButton, Badge, Box,
  Menu, MenuItem, Divider, ListItemIcon, ListItemText, Chip,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../../contexts/AuthContext';
import PushTestDialog from '../common/PushTestDialog';

const ROLE_LABELS = {
  admin: 'Administrador',
  manager: 'Gestor',
  engineer: 'Ingeniero',
  viewer: 'Solo lectura',
};

export default function Header({ onToggle }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [pushTestOpen, setPushTestOpen] = useState(false);

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <IconButton color="inherit" edge="start" onClick={onToggle} sx={{ mr: 1 }}>
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" noWrap component="div"
          sx={{ flexGrow: 1, fontSize: { xs: '1rem', md: '1.25rem' } }}>
          Gestor de Proyectos Industriales
        </Typography>
        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1, alignItems: 'center' }}>
          <Box
            sx={{
              height: 40,
              maxWidth: 160,
              display: 'flex',
              alignItems: 'center',
              mr: 1,
            }}
          >
            <img
              src="/logo/logo.png"
              alt="Logo"
              style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }}
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          {user && (
            <Typography variant="body2" sx={{ mr: 1, opacity: 0.9, display: { xs: 'none', md: 'block' } }}>
              {user.full_name}
            </Typography>
          )}
          <IconButton color="inherit" sx={{ display: { xs: 'none', md: 'inline-flex' } }}>
            <Badge badgeContent={0} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton>
          <IconButton color="inherit" onClick={(e) => setAnchorEl(e.currentTarget)}>
            <AccountIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            {user && (
              <Box sx={{ px: 2, py: 1 }}>
                <Typography variant="subtitle2" fontWeight="bold">{user.full_name}</Typography>
                <Typography variant="caption" color="textSecondary">{user.email}</Typography>
                <Box sx={{ mt: 0.5 }}>
                  <Chip label={ROLE_LABELS[user.role] || user.role} size="small" color="primary" variant="outlined" />
                </Box>
              </Box>
            )}
            <Divider />
            <MenuItem onClick={() => { setAnchorEl(null); navigate('/profile'); }}>
              <ListItemIcon><PersonIcon fontSize="small" /></ListItemIcon>
              <ListItemText>Mi Cuenta</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => { setAnchorEl(null); setPushTestOpen(true); }}>
              <ListItemIcon><NotificationsIcon fontSize="small" /></ListItemIcon>
              <ListItemText>Probar notificaciones</ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem onClick={() => { setAnchorEl(null); logout(); }}>
              <ListItemIcon><LogoutIcon fontSize="small" /></ListItemIcon>
              <ListItemText>Cerrar Sesion</ListItemText>
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
      <PushTestDialog open={pushTestOpen} onClose={() => setPushTestOpen(false)} />
    </AppBar>
  );
}
